export default __webpack_public_path__ + "assets/images/waxes_fat_chemicals_0a41b15ddac8bd958e1114d1be56f05d.jpg";